// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-helper {\n  color: #999;\n  font-style: italic;\n  font-weight: 400;\n  font-size: 0.85em;\n}\n", ""]);
// Exports
module.exports = exports;
